/**
 * @module project/components/header_buttons
 */
import React, { PropTypes } from 'react';
import classNames from 'classnames';
import ProjectParticipateButton from 'project/containers/project_participate_button';
import WatchlistButton from 'project/containers/watch_project_button';
import ReserveButton from 'project/containers/reserve_button';
import Icon from 'common/components/svg_icon';
import Menu from 'project/containers/header_actions_menu';

/**
 * Project page specific header buttons
 *
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 * @author Jing Wang <jing@crowdspring.com>
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
const HeaderButtons = ({
      toggleRightDrawer, toggleParticipateForm, requestAccess,
      showFilters, canRequestAccess, canParticipate, canWatch
}) => (
  <div className="project-header-controls">

    {/* Reverse order for float right */}

    <Menu />

    <ReserveButton />

    {canParticipate &&
    <div className="project-participate button-wrapper hide-for-small-only">
      <ProjectParticipateButton
        toggleParticipateForm={toggleParticipateForm}
      />
    </div>}

    {canRequestAccess &&
    <div className="button-wrapper hide-for-small-only">
      <button className="btn btn-primary" onClick={requestAccess}>
        Request access
      </button>
    </div>}

    {showFilters && <div className="hide-for-large button-wrapper">
      <button
        type="button"
        onClick={toggleRightDrawer}
        className="btn btn-icon-only btn-filter header-btn-filter"
      >
        <Icon className={classNames('svg-icon', 'svg-icon-lg', 'filter')} icon="filter" />
      </button>
    </div>}

    {canWatch &&
    <div className="button-wrapper project-watchers hide-for-small-only">
      <WatchlistButton classes="btn btn-text" />
    </div>}

  </div>
);

HeaderButtons.propTypes = {
  toggleRightDrawer: PropTypes.func.isRequired,
  toggleParticipateForm: PropTypes.func.isRequired,
  requestAccess: PropTypes.func.isRequired,
  showFilters: PropTypes.bool,
  canRequestAccess: PropTypes.bool,
  canParticipate: PropTypes.bool,
  canWatch: PropTypes.bool,
};

export default HeaderButtons;



// WEBPACK FOOTER //
// ./project/components/header_buttons.jsx